import { Injectable } from "@angular/core";
import { ApicallOption, ApicallService } from "@core-services/apicall.service";
import { Profile } from "@models";
import { Observable } from "rxjs";
import moment from "moment";
import { ProfileModel } from "@modules/main/components/profile/new-profile/entities/profile-model";
import { map } from "rxjs/operators";

@Injectable({
	providedIn: "root"
})
export class ProfileRemote {
	public constructor(private readonly apicallService: ApicallService) {}

	public getProfile$(): Observable<ProfileModel> {
		const option = new ApicallOption(Profile);
		return this.apicallService.get("user/profile", option).pipe(
			map((res) => {
				res[0].profile_id = res[0].id;
				return res[0];
			})
		);
	}

	public postProfile$(tempProfile: ProfileModel): Observable<ProfileModel> {
		let merged = "+" + tempProfile.phonecode + tempProfile.phonenumber; // Merge the two frontend fields in one backend field
		if (merged === "") {
			merged = "+";
		} // the "mobile" field in the payload only accepts the string with a plus
		const data = {
			...tempProfile,
			birthday: moment(tempProfile.fullBirthday, "DDMMYYYY").format("YYYY-MM-DD"),
			mobile: merged
		};
		return this.apicallService.post("user/profile", new ApicallOption(Profile, data)).pipe(map((res) => res[0]));
	}
}
